import { type ReactNode } from 'react';

/**
 * Tabs simples controladas por el padre. Se pasa el active key y un
 * setter. Cada tab define key, label y opcionalmente un badge numérico.
 */
export type TabDef = {
  key: string;
  label: ReactNode;
  badge?: ReactNode;
};

export function Tabs({
  tabs,
  active,
  onChange,
  className = '',
}: {
  tabs: TabDef[];
  active: string;
  onChange: (key: string) => void;
  className?: string;
}) {
  return (
    <div className={`mb-4 flex items-center gap-1 border-b border-slate-200 ${className}`}>
      {tabs.map((t) => {
        const isActive = t.key === active;
        return (
          <button
            key={t.key}
            type="button"
            onClick={() => onChange(t.key)}
            className={`-mb-px cursor-pointer rounded-t-md px-3 py-2 text-sm font-medium transition focus:outline-none ${
              isActive
                ? 'border border-b-white border-slate-200 bg-white text-slate-900'
                : 'text-slate-500 hover:text-slate-700'
            }`}
            aria-current={isActive ? 'page' : undefined}
          >
            <span>{t.label}</span>
            {t.badge != null && (
              <span className={`ml-2 inline-flex min-w-[1.5rem] items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${
                isActive ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-600'
              }`}>
                {t.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
